import { useTheme } from '../context/ThemeProvider'
import { Outlet, NavLink } from 'react-router-dom'

import useLogout from '../hooks/useLogout'
import useAuth from '../hooks/useAuth'

import InfoMessage from '../components/InfoMessage'
import Loader from '../components/Loader'
import Footer from '../components/Footer'

function AuthLayout() {
  const { auth, showLoader, mainDpt, showInfo } = useAuth()

  const theme = useTheme()

  const style = { backgroundColor: theme.backgroundColor, color: theme.textColor, logo: theme.logo, footer: theme.footer }

  const navClasses =
    'py-1 px-3 rounded-md items-center hover:bg-[#2babe0] hover:text-white text-center'
  const logout = useLogout()

  const guideLink = () => {
    let guide =
      'https://kisdigital.s3.eu-west-2.amazonaws.com/hub/SAS+-+Portal+Guide.pdf'
    if (window.location.href.includes('schoosmutuals')) {
      guide =
        'https://kisdigital.s3.eu-west-2.amazonaws.com/hub/Schools+Mutual+-+Portal+Guide.pdf'
    }
    return guide
  }

  return (
    <div className="bg-slate-50/50 w-full">
      {showLoader && <Loader />}
      {showInfo?.message && <InfoMessage />}
      <div className="absolute w-full">
        {auth.token ? (
          <div className="h-[50px] sm:h-[60px] bg-white shadow z-[100] relative flex justify-between items-center px-4 md:px-8">
            <h2
              className="text-base sm:text-xl font-bold "
              style={{ color: style.color }}
            >
              <NavLink to={`/dashboard`}>{theme.name}</NavLink>
            </h2>
            {/* if logged in */}
            <div className="flex space-x-4 items-center">
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  isActive
                    ? 'bg-[#2babe0] text-white ' +
                      navClasses +
                      ' pointer-events-none'
                    : navClasses + ''
                }
              >
                Dashboard
              </NavLink>
              {auth?.schools?.length > 1 && (
                <NavLink
                  to="account-select"
                  className={({ isActive }) =>
                    isActive
                      ? 'bg-[#2babe0] ' +
                        navClasses +
                        ' pointer-events-none text-white'
                      : navClasses + ' '
                  }
                >
                  <span className="w-[300px]">Switch School</span>
                </NavLink>
              )}
              {mainDpt !== 'CC' && (
                <a
                  href={guideLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={navClasses + ' '}
                >
                  <span className="w-[300px]">View Guide</span>
                </a>
              )}
              <p
                className="text-slate-800 text-sm sm:text-base cursor-pointer"
                onClick={logout}
              >
                Logout
              </p>
            </div>
          </div>
        ) : null}
        <div
          className="h-[150px] sm:h-[80px] z-[9] relative w-full"
          style={{ backgroundColor: style.backgroundColor }}
        ></div>
        <div
          className="w-full h-[283px] sm:block hidden"
          style={{ backgroundImage: theme.backgroundImage }}
        >
          &nbsp;
        </div>
      </div>

      <div className="relative pt-[90px] sm:pt-28">
        <div className="flex items-center flex-col z-10 relative w-full px-4 md:px-8 min-h-[650px]">
          <Outlet />
        </div>
        <Footer theme={theme} />
      </div>
    </div>
  )
}

export default AuthLayout
